import React, { SVGProps } from 'react';

export const CalendarIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 18,
  height = 18,
  fill = 'white',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 18 18"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 6.75C1.5 5.3355 1.5 4.629 1.9395 4.1895C2.379 3.75 3.0855 3.75 4.5 3.75H13.5C14.9145 3.75 15.621 3.75 16.0605 4.1895C16.5 4.629 16.5 5.3355 16.5 6.75C16.5 7.10325 16.5 7.28025 16.3905 7.3905C16.2802 7.5 16.1025 7.5 15.75 7.5H2.25C1.89675 7.5 1.71975 7.5 1.6095 7.3905C1.5 7.28025 1.5 7.1025 1.5 6.75ZM1.5 13.5C1.5 14.9145 1.5 15.621 1.9395 16.0605C2.379 16.5 3.0855 16.5 4.5 16.5H13.5C14.9145 16.5 15.621 16.5 16.0605 16.0605C16.5 15.621 16.5 14.9145 16.5 13.5V9.75C16.5 9.39675 16.5 9.21975 16.3905 9.1095C16.2802 9 16.1025 9 15.75 9H2.25C1.89675 9 1.71975 9 1.6095 9.1095C1.5 9.21975 1.5 9.3975 1.5 9.75V13.5Z"
        fill={fill}
      />
      <path
        d="M5.25 2.25V4.5M12.75 2.25V4.5"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};
